import environment from '../../../common/environment';

/*----- HELPERS -----*/
export function getSuggestionsApiCall(searchTerms = '', catalog = 'unified') {
  const catalogMapping: any = {
    unified: 'UNIFIED',
    he: 'HE',
    seg: 'SEG_PROGRAM',
    content: 'UNIFIED',
    professional: 'PROFESSIONAL',
  };

  const body: any = { searchTerms, catalog: catalogMapping[catalog] || catalog };

  return fetch(`${environment().searchServiceUrl}/suggestions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  }).then((res) => (res.status <= 399 ? res.json() : false));
}
